import {
  CustomExpense as GQLCustomExpense,
  CustomExpenseDeductedTypeEnum as GQLCustomExpenseDeductedTypeEnum,
  CustomExpenseDueEnum as GQLCustomExpenseDueEnum,
} from '../../generated/graphql';

export const CustomExpenseDueEnum = Object.freeze({
  ToArtist: GQLCustomExpenseDueEnum.ToArtist,
  ToVenue: GQLCustomExpenseDueEnum.ToVenue,
});

export type CustomExpenseDueEnum = (typeof CustomExpenseDueEnum)[keyof typeof CustomExpenseDueEnum];

export const CustomExpenseDeductedTypeEnum = Object.freeze({
  Gross: GQLCustomExpenseDeductedTypeEnum.Gross,
  Net: GQLCustomExpenseDeductedTypeEnum.Net,
});

export type CustomExpenseDeductedTypeEnum = (typeof CustomExpenseDeductedTypeEnum)[keyof typeof CustomExpenseDeductedTypeEnum];

export type CustomExpense = {
  id?: number;
  amount?: number;
  description?: string;
  due?: CustomExpenseDueEnum;
  deductedType?: CustomExpenseDeductedTypeEnum;
  _destroy?: boolean;
};

export type CustomExpenseAttributes = CustomExpense;

export const customExpenseFromGql = (item: GQLCustomExpense): CustomExpense => ({
  id: item.id,
  amount: item.amount ?? undefined,
  description: item.description ?? undefined,
  due: item.due as CustomExpenseDueEnum | undefined,
  deductedType: item.deductedType as CustomExpenseDeductedTypeEnum | undefined,
  _destroy: item._destroy ?? undefined,
});
